/* Shipping Protection — cart page opt-out control
 * Automatically adds the $3 Shipping Protection product when the qualifying
 * cart subtotal (excluding protection itself) is $100 or more, unless the
 * customer checks "Decline Shipping Protection". The decline choice is stored
 * as a private Shopify cart attribute so section refreshes and cart updates do
 * not add the fee back. Below $100 the protection line is removed.
 *
 * Cart sections are re-rendered in place after protection changes. All event
 * listeners are delegated/subscribed so they survive those replacements.
 */
(function () {
  var VARIANT_ID = 50457017057472;
  var THRESHOLD_CENTS = 10000;
  var DECLINE_ATTRIBUTE = '_shipping_protection_declined';
  var isBusy = false;
  var fallbackTimer = null;

  function getContainer() {
    return document.getElementById('shipping-protection-container');
  }

  function getCheckbox() {
    return document.getElementById('ShippingProtection');
  }

  function isDeclined(cart) {
    return !!(cart && cart.attributes && cart.attributes[DECLINE_ATTRIBUTE] === 'yes');
  }

  function itemPrice(item) {
    if (typeof item.original_line_price === 'number') return item.original_line_price;
    if (typeof item.line_price === 'number') return item.line_price;
    return 0;
  }

  function getCartSummary(cart) {
    var protectionLine = null;
    var qualifyingSubtotal = 0;
    (cart.items || []).forEach(function (item) {
      if (item.variant_id === VARIANT_ID) {
        protectionLine = item;
      } else {
        // Eligibility is based on merchandise subtotal before discounts, which
        // matches the Liquid section and prevents threshold flicker when a
        // $100+ cart receives an automatic discount.
        qualifyingSubtotal += itemPrice(item);
      }
    });
    return {
      protectionLine: protectionLine,
      qualifyingSubtotal: qualifyingSubtotal,
      qualifies: qualifyingSubtotal >= THRESHOLD_CENTS,
      declined: isDeclined(cart),
    };
  }

  function updateControl(cart) {
    var container = getContainer();
    var checkbox = getCheckbox();
    if (!container || !checkbox || !cart || !cart.items) return;

    var state = getCartSummary(cart);
    container.hidden = !state.qualifies;
    checkbox.checked = state.declined;
    checkbox.disabled = isBusy;
  }

  function replaceSection(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var newEl = doc.querySelector(selector);
    var oldEl = document.querySelector(selector);
    if (newEl && oldEl) oldEl.replaceWith(newEl);
  }

  function rerenderDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return Promise.resolve();
    return fetch('/?sections=cart-drawer,cart-icon-bubble', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var parse = function (html, sel) {
          return new DOMParser().parseFromString(html || '', 'text/html').querySelector(sel);
        };
        var newInner = parse(sections['cart-drawer'], '#CartDrawer');
        var oldInner = document.getElementById('CartDrawer');
        if (newInner && oldInner) oldInner.innerHTML = newInner.innerHTML;
        var newDrawer = parse(sections['cart-drawer'], 'cart-drawer');
        if (newDrawer) drawer.classList.toggle('is-empty', newDrawer.classList.contains('is-empty'));
        var newBubble = parse(sections['cart-icon-bubble'], '.shopify-section');
        var oldBubble = document.getElementById('cart-icon-bubble');
        if (newBubble && oldBubble) oldBubble.innerHTML = newBubble.innerHTML;
        var overlay = document.getElementById('CartDrawer-Overlay');
        if (overlay && drawer.close) overlay.addEventListener('click', drawer.close.bind(drawer));
      });
  }

  function rerenderCartSections() {
    var jobs = [rerenderDrawer()];
    var itemsEl = document.getElementById('main-cart-items');
    var footerEl = document.getElementById('main-cart-footer');
    if (itemsEl || footerEl) {
      var itemsSectionId = (itemsEl && itemsEl.dataset.id) || 'main-cart-items';
      var footerSectionId = (footerEl && footerEl.dataset.id) || 'main-cart-footer';
      jobs.push(Promise.all([
        fetch('/cart?section_id=' + encodeURIComponent(itemsSectionId)).then(function (r) { return r.text(); }),
        fetch('/cart?section_id=' + encodeURIComponent(footerSectionId)).then(function (r) { return r.text(); }),
      ]).then(function (results) {
        replaceSection(results[0], 'cart-items');
        replaceSection(results[1], '#main-cart-footer');
      }));
    }
    return Promise.all(jobs);
  }

  function cartUpdate(body) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart update failed: ' + response.status);
      return response.json();
    });
  }

  function fetchCart() {
    return fetch('/cart.js?shipping_protection_refresh=' + Date.now(), {
      cache: 'no-store',
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart load failed: ' + response.status);
      return response.json();
    });
  }

  function addProtection() {
    // Reconciliation calls this only when the line is absent. Add quantity 1;
    // the isBusy guard prevents duplicate concurrent adds.
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: VARIANT_ID, quantity: 1 }] }),
    }).then(function (response) {
      if (!response.ok) throw new Error('Shipping protection add failed: ' + response.status);
      return response.json();
    });
  }

  function removeProtection() {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: String(VARIANT_ID), quantity: 0 }),
    }).then(function (response) {
      if (!response.ok) throw new Error('Shipping protection remove failed: ' + response.status);
      return response.json();
    });
  }

  function finishMutation() {
    return rerenderCartSections()
      .then(function () { return loadAndReconcile(true); })
      .catch(function (error) {
        console.error('Shipping protection: update failed', error);
      })
      .finally(function () {
        isBusy = false;
        var checkbox = getCheckbox();
        if (checkbox) checkbox.disabled = false;
      });
  }

  function reconcileCart(cart) {
    if (!cart || !cart.items) return Promise.resolve();
    updateControl(cart);
    if (isBusy) return Promise.resolve();

    var state = getCartSummary(cart);
    var action = null;
    if (state.qualifies && !state.declined && !state.protectionLine) {
      action = addProtection();
    } else if ((!state.qualifies || state.declined) && state.protectionLine) {
      action = removeProtection();
    }

    if (!action) return Promise.resolve();
    isBusy = true;
    updateControl(cart);
    return action.then(finishMutation, function (error) {
      isBusy = false;
      updateControl(cart);
      console.error('Shipping protection: automatic update failed', error);
    });
  }

  function loadAndReconcile(forceControl) {
    return fetchCart()
      .then(function (cart) {
        if (forceControl) updateControl(cart);
        return reconcileCart(cart);
      })
      .catch(function (error) {
        console.error('Shipping protection: could not load cart', error);
      });
  }

  function setDeclined(declined) {
    if (isBusy) return;
    isBusy = true;
    var checkbox = getCheckbox();
    if (checkbox) checkbox.disabled = true;

    var attributes = {};
    attributes[DECLINE_ATTRIBUTE] = declined ? 'yes' : '';
    cartUpdate({ attributes: attributes })
      .then(function (cart) {
        var state = getCartSummary(cart);
        if (declined && state.protectionLine) return removeProtection();
        if (!declined && state.qualifies && !state.protectionLine) return addProtection();
        return cart;
      })
      .then(finishMutation, function (error) {
        isBusy = false;
        console.error('Shipping protection: decline update failed', error);
        return loadAndReconcile(true);
      });
  }

  document.addEventListener('DOMContentLoaded', function () { loadAndReconcile(true); });

  document.addEventListener('change', function (event) {
    if (event.target && event.target.id === 'ShippingProtection') {
      setDeclined(event.target.checked);
    }
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      // Product-form adds publish the single added line (no items array), so
      // only trust cartData when it is a full cart object.
      if (event && event.cartData && Array.isArray(event.cartData.items) && typeof event.cartData.item_count === 'number') {
        reconcileCart(event.cartData);
      } else {
        loadAndReconcile(true);
      }
    });
  }

  // The theme refreshes cart sections after quantity +/- changes. Reconcile
  // once that request finishes; this fallback also covers themes/events that
  // do not publish cartUpdate reliably.
  document.addEventListener('click', function (event) {
    var target = event.target.closest('button[name="plus"], button[name="minus"], cart-remove-button, .cart-remove-button');
    if (!target) return;
    if (fallbackTimer) clearTimeout(fallbackTimer);
    fallbackTimer = setTimeout(function () { loadAndReconcile(true); }, 2000);
  });

  // Sidebar cart: reconcile whenever it opens and after typed quantity changes.
  function scheduleReconcile(ms) {
    if (fallbackTimer) clearTimeout(fallbackTimer);
    fallbackTimer = setTimeout(function () { loadAndReconcile(true); }, ms);
  }
  document.addEventListener('change', function (event) {
    if (event.target && event.target.closest && event.target.closest('cart-drawer .quantity__input, cart-items .quantity__input')) scheduleReconcile(2000);
  });
  document.addEventListener('cp:cart-added', function () { scheduleReconcile(600); });
  document.addEventListener('DOMContentLoaded', function () {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !window.MutationObserver) return;
    var wasActive = drawer.classList.contains('active');
    new MutationObserver(function () {
      var active = drawer.classList.contains('active');
      if (active && !wasActive) scheduleReconcile(300);
      wasActive = active;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  });
})();
